import axios from "axios";

const env = process.env.NODE_ENV;
const config = {
  BASE_URL: process.env.REACT_APP_API_URL,
};

if (env === "development") {
  config.BASE_URL = process.env.REACT_APP_PUBLIC_API_ENDPOINT_LOCAL;
}

const fetchApi = () => {
  const defaultOption = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "content-type": "application/json",
      Accept: "application/json",
    },
  };

  let instance = axios.create(defaultOption);

  return instance;
};

const apiClientNgRok = {
  get(path) {
    return fetchApi().get(`http://192.168.1.7:8001/${path}`);
  },
};
const apiClient = {
  put(path, params) {
    return fetchApi().put(`${config.BASE_URL}${path}`, params);
  },
  get(path) {
    return fetchApi().get(`${config.BASE_URL}${path}`);
  },
  post(path, params) {
    return fetchApi().post(`${config.BASE_URL}${path}`, JSON.stringify(params));
  },

  upload(path, params) {
    return fetchApi().post(path, params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default apiClient;
export { config, apiClientNgRok };
